import React from 'react';
import PropTypes from 'prop-types';
import MaterialUISnackbar from '@material-ui/core/Snackbar';
import { withStyles } from '@material-ui/core/styles';

import dagstorp from 'LegacyWeployDesignLanguage/dagstorp';

const styles = () => ({
  root: {
    borderRadius: dagstorp.borderRadius,
  },
});

const BOTTOM_LEFT = {
  vertical: 'bottom',
  horizontal: 'left',
};

const Snackbar = ({
  visible,
  autoHideDuration,
  message,
  classes,
  onClose,
  onEntered,
}) => (
  <MaterialUISnackbar
    ContentProps={{
      classes: { root: classes.root },
    }}
    key={message}
    anchorOrigin={BOTTOM_LEFT}
    open={visible}
    message={message}
    onClose={onClose}
    autoHideDuration={autoHideDuration}
    onEntered={onEntered}
  />
);

Snackbar.propTypes = {
  classes: PropTypes.object.isRequired,
  visible: PropTypes.bool,
  message: PropTypes.string.isRequired,
  autoHideDuration: PropTypes.number,
  onClose: PropTypes.func,
  onEntered: PropTypes.func,
};

Snackbar.defaultProps = {
  visible: false,
  autoHideDuration: null,
  onClose: () => {},
  onEntered: () => {},
};

export default withStyles(styles)(Snackbar);
